import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/member/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/member/create', data)
}
export function updateStatus (data) {
  return request.post('/business/member/updateStatus', data)
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/member/exportExcel', data, {
    download: true
  })
}

// 修改
export function updateById (data) {
  return request.post('/business/member/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/member/delete/${id}`)
}
export function getById (id) {
  return request.get(`/business/member/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/member/delete/batch', {
    params: {
      ids
    }
  })
}
